<template>
  <div class="banner">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(banner,idx) in bannerList" :key="idx">
        <img :src="requestUrl + '/news/route/file/downloadfile/true/' + banner.newsContentCoverList" alt="">
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import url from '@/assets/public/url'
export default {
  name: "Banner",
  components: {},
  props: {
    bannerList: Array
  },
  data() {
    return {
      requestUrl: url.url,
      swiperOptions: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 3000
      }
    }
  },
  methods: {},
  mounted() {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.banner, .banner img
  width 100%
  height 500px

</style>



// WEBPACK FOOTER //
// src/pages/Index/components/Banner.vue